<template>
  <div class="tab">
    <router-link
      class="tab-item"
      v-for="tab in tabs"
      :key="tab.path"
      :to="tab.path"
      :class="{ 'tab-item--active': isActive(tab.path) }"
    >
      <RewardBubbleView
        v-if="tab.path === '/reward' && rewardBubbleAmount > 0"
        class="tab-item__reward-bubble"
        variant="tab"
        :text="rewardBubbleText"
      />
      <img
        :src="isActive(tab.path) ? tab.activeIcon : tab.icon"
        class="tab-item__icon"
        alt=""
      />
      <span
        class="tab-item__label"
        :style="{ color: isActive(tab.path) ? '#FF43A9' : '' }"
      >{{ tab.name }}</span>
    </router-link>
  </div>
</template>

<script>
import recordNormal from '@/assets/images/ic_tab_record.png'
import recordSelected from '@/assets/images/ic_tab_record_selected.png'
import homeNormal from '@/assets/images/ic_tab_home.png'
import homeSelected from '@/assets/images/ic_tab_home_selected.png'
import videoNormal from '@/assets/images/ic_tab_video.png'
import videoSelected from '@/assets/images/ic_tab_video_selected.png'
import rewardNormal from '@/assets/images/ic_tab_reward.png'
import rewardSelected from '@/assets/images/ic_tab_reward_selected.png'
import meNormal from '@/assets/images/ic_tab_me.png'
import meSelected from '@/assets/images/ic_tab_me_selected.png'
import { ENABLE_REWARD_TASKS } from '@/assets/js/featureFlags'
import emitter from '@/assets/js/eventbus'
import RewardBubbleView from '@/components/reward/RewardBubbleView.vue'
import { getRewardTasks, REWARD_TASK_LIST_CHANGE_EVENT } from '@/service/rewardService'
import { claimableRewardAmountForTasks } from '@/service/rewardBubble'
import { useUserStore } from '@/store/user'

export default {
  name: 'tab',
  components: {
    RewardBubbleView
  },
  setup () {
    const userStore = useUserStore()
    return {
      userStore
    }
  },
  data () {
    return {
      rewardBubbleAmount: 0
    }
  },
  computed: {
    tabs () {
      return [
        {
          name: this.$t('tab.home'),
          path: '/home',
          activeIcon: homeSelected,
          icon: homeNormal
        },
        {
          name: this.$t('tab.video'),
          path: '/video',
          activeIcon: videoSelected,
          icon: videoNormal
        },
        ...(ENABLE_REWARD_TASKS
          ? [{
              name: this.$t('tab.reward'),
              path: '/reward',
              activeIcon: rewardSelected,
              icon: rewardNormal
            }]
          : []),
        {
          name: this.$t('tab.record'),
          path: '/record',
          activeIcon: recordSelected,
          icon: recordNormal
        },
        {
          name: this.$t('tab.mine'),
          path: '/mine',
          activeIcon: meSelected,
          icon: meNormal
        }
      ]
    },
    rewardBubbleText () {
      return `+${this.rewardBubbleAmount}`
    }
  },
  watch: {
    'userStore.uid' () {
      this.refreshRewardBubble()
    }
  },
  mounted () {
    emitter.on(REWARD_TASK_LIST_CHANGE_EVENT, this.handleRewardTaskListChange)
    this.refreshRewardBubble()
  },
  beforeUnmount () {
    emitter.off(REWARD_TASK_LIST_CHANGE_EVENT, this.handleRewardTaskListChange)
  },
  methods: {
    isActive (path) {
      return this.$route.path.includes(path)
    },
    handleRewardTaskListChange () {
      this.refreshRewardBubble()
    },
    async refreshRewardBubble () {
      if (!ENABLE_REWARD_TASKS) {
        this.rewardBubbleAmount = 0
        return
      }

      try {
        const { tasks } = await getRewardTasks(this.userStore.uid)
        this.rewardBubbleAmount = claimableRewardAmountForTasks(tasks)
      } catch {
        this.rewardBubbleAmount = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--tab-height);
  z-index: 100;
  display: flex;
  background-color: $color-background;
  border-top: 1px solid rgba(255, 255, 255, 0.08);

  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .tab-item {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;

    &__icon {
      width: 24px;
      height: 24px;
      display: block;
      object-fit: contain;
    }

    &__label {
      font-size: 10px;
      color: #BDBDBD;
      line-height: 1;
    }

    &__reward-bubble {
      position: absolute;
      left: 50%;
      bottom: calc(100% + 4px);
      z-index: 1;
      transform: translateX(-50%);
    }

    &--active &__label {
      color: $color-theme;
    }
  }
}
</style>
